export const BOT = 'bot';
export const USER = 'user';
export const ADMIN = 'admin';
export const EMPLOYEE = 'employee';
